export default __webpack_public_path__ + "static/media/vix.e96bd0f1.webp";